import {
	Box,
	Breadcrumbs,
	Button,
	FormControl,
	FormControlLabel,
	Grid,
	InputLabel,
	LinearProgress,
	MenuItem,
	Paper,
	Radio,
	RadioGroup,
	Select,
	Stack,
	TextField,
	useMediaQuery,
	useTheme,
} from '@mui/material'
import {
	BtnBox,
	PageBg2,
	PageWrap,
	SearchRowItem,
	TitleText,
} from 'components/FrameworkStyle'
import { getSettings } from 'helpers/storage'
import { selectuserInfo } from 'hooks/userInfo'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import ClientSearchPopup from 'views/test/clientSearchPopup'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/ko'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import moment from 'moment'
import 'moment/locale/ko'
import { alertModal, compareDate, isValidDateType } from 'util/util'
import DownloadIcon from '@mui/icons-material/Download'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone'
import { PageBg } from 'components/ComponentStyles'
import {
	DataGridPremium,
	GridColDef,
	GridColumnGroupingModel,
	GridDensity,
	GridSelectionModel,
	GridToolbar,
	koKR,
	useGridApiRef,
} from '@mui/x-data-grid-premium'
import ExcelJS from 'exceljs'
import dayjs from 'dayjs'

const columns: GridColDef[] = [
	{
		field: 'id',
		headerName: 'ID',
		width: 100,
		headerAlign: 'center',
	},
	{
		field: 'a',
		headerName: '접수일',
		width: 300,
		headerAlign: 'center',
	},
	{
		field: 'b',
		headerName: '검사명',
		width: 300,
		headerAlign: 'center',
	},
	{
		field: 'c',
		headerName: '양설률(%)',
		width: 300,
		headerAlign: 'center',
	},
	{
		field: 'd',
		headerName: '양성건수',
		width: 300,
		headerAlign: 'center',
	},
	{
		field: 'e',
		headerName: '오염률(%)',
		width: 300,
		headerAlign: 'center',
	},
	{
		field: 'f',
		headerName: '오염균 합계',
		width: 300,
		headerAlign: 'center',
	},
	{
		field: 'g1',
		headerName: 'CNS',
		width: 300,
		headerAlign: 'center',
	},
	{
		field: 'g2',
		headerName: 'Bacillus spp.',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'g3',
		headerName: 'Corynebacterium spp.',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'g4',
		headerName: 'Micrococcus spp.',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'g5',
		headerName: '기타(Gram + rod, Aerococcus spp., Propionibacterium spp.)',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'h',
		headerName: '총 의뢰건수',
		width: 200,
		headerAlign: 'center',
		type: 'number',
	},
]

export const groupingModel: GridColumnGroupingModel = [
	{
		groupId: 'pos',
		headerName: '균명',
		headerAlign: 'center',
		description: '',
		children: [
			{ field: 'g1' },
			{ field: 'g2' },
			{ field: 'g3' },
			{ field: 'g4' },
			{ field: 'g5' },
		],
	},
]

const columnsSub: GridColDef[] = [
	{
		field: 'id',
		headerName: '순번',
		width: 100,
		headerAlign: 'center',
	},
	{
		field: 'a',
		headerName: '구분',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'b',
		headerName: '환자명',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'c',
		headerName: '성별',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'd',
		headerName: '병원명',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'e',
		headerName: '검사명',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'f',
		headerName: '균주명',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'g',
		headerName: '접수일자',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'h',
		headerName: '접수번호',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'i',
		headerName: '차트번호',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'j',
		headerName: '병동',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'k',
		headerName: '진료과',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'l',
		headerName: '진료의',
		width: 200,
		headerAlign: 'center',
	},
	{
		field: 'm',
		headerName: '병원 바코드 번호',
		width: 200,
		headerAlign: 'center',
	},
]

const locales = ['ko'] as const

const BloodStat = () => {
	const theme = useTheme()
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'))
	const userInfo = useSelector(selectuserInfo)
	const [locale, setLocale] = useState<(typeof locales)[number]>('ko')

	const env = getSettings()
	const [disabledSave, setDisabledSave] = useState(true)
	const [disabledDel, setDisabledDel] = useState(true)
	const [disabledSearch, setDisabledSearch] = useState(false)
	const [disabledReset, setDisabledReset] = useState(false)

	const [dateRange, setDateRange] = useState('1d')

	const [search, setSearch] = useState({
		clientID: userInfo.infoType === 'C' ? userInfo.clientID : 0,
		searchType: 'R',
		startDate: moment(new Date()).isBefore('2023-08')
			? '2023-08'
			: moment().subtract(1, 'months').format('YYYY-MM'),
		endDate: moment().format('YYYY-MM'),
	})

	const onKeyUp = (e: any) => {
		if (e.keyCode === 13) actionSearch()
	}

	const actionSearch = () => {
		const startDate = moment(search.startDate, ['YYYY-MM-DD', 'YYYY-MM'], true)
		const endDate = moment(search.endDate, ['YYYY-MM-DD', 'YYYY-MM'], true)

		if (!startDate.isValid() || !endDate.isValid()) {
			alertModal('날짜 형식이 올바르지 않습니다.', 'error', () => {})
			return
		}

		if (endDate.isBefore(startDate, 'day')) {
			alertModal('종료일이 시작일보다 작습니다.', 'error', () => {})
			return
		}

		if (
			endDate.startOf('day').diff(startDate.startOf('day'), 'months', true) > 12
		) {
			alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
			return
		}
	}
	const actionReset = () => {
		setSearch({
			clientID: userInfo.infoType === 'C' ? userInfo.clientID : 0,
			searchType: 'R',
			startDate: moment(new Date()).isBefore('2023-08')
				? '2023-08'
				: moment().subtract(1, 'months').format('YYYY-MM'),
			endDate: moment().format('YYYY-MM'),
		})
	}
	const actionExcelDownload = async () => {
		setSelectionModel([])
		setSubSelectionModel([])

		// 테두리 스타일 정의
		const borderStyle: Partial<ExcelJS.Borders> = {
			top: { style: 'thin', color: { argb: 'FF000000' } },
			left: { style: 'thin', color: { argb: 'FF000000' } },
			bottom: { style: 'thin', color: { argb: 'FF000000' } },
			right: { style: 'thin', color: { argb: 'FF000000' } },
		}

		// 셀 너비 자동 조정 함수
		const autoFitColumns = (
			sheet: ExcelJS.Worksheet,
			colDefs: GridColDef[],
			data: any[],
			startCol: number = 1,
		) => {
			colDefs.forEach((col, index) => {
				// 헤더 길이
				let maxLength = String(col.headerName || '').length
				// 데이터 중 최대 길이 찾기
				data.forEach((row) => {
					const cellValue = String(row[col.field] ?? '')
					if (cellValue.length > maxLength) {
						maxLength = cellValue.length
					}
				})
				// 여유 공간 추가 (한글은 2배 정도 너비 필요)
				const column = sheet.getColumn(startCol + index)
				column.width = Math.min(Math.max(maxLength * 1.5 + 2, 10), 50)
			})
		}

		// ExcelJS Workbook 생성
		const workbook = new ExcelJS.Workbook()
		const sheet = workbook.addWorksheet('혈액배양 통계')

		// 첫 번째 테이블: mstRef (통계)
		const mstColumns = columns.filter((col) => col.field !== 'rowNum')
		// 헤더 추가
		const mstHeaderRow = sheet.addRow(mstColumns.map((col) => col.headerName))
		// 헤더 스타일 적용
		mstHeaderRow.eachCell((cell) => {
			cell.border = borderStyle
			cell.alignment = { horizontal: 'center' }
		})
		// 데이터 추가
		rows.forEach((row: any) => {
			const dataRow = sheet.addRow(mstColumns.map((col) => row[col.field] ?? ''))
			dataRow.eachCell((cell) => {
				cell.border = borderStyle
			})
		})

		// 첫 번째 테이블 컬럼 너비 자동 조정
		autoFitColumns(sheet, mstColumns, rows)

		// 2행 띄우기
		sheet.addRow([])
		sheet.addRow([])

		// 두 번째 테이블: slvRef (상세)
		const slvColumns = columnsSub.filter((col) => col.field !== 'rowNum')
		// 헤더 추가
		const slvHeaderRow = sheet.addRow(slvColumns.map((col) => col.headerName))
		// 헤더 스타일 적용
		slvHeaderRow.eachCell((cell) => {
			cell.border = borderStyle
			cell.alignment = { horizontal: 'center' }
		})
		// 데이터 추가
		subRows.forEach((row: any) => {
			const dataRow = sheet.addRow(slvColumns.map((col) => row[col.field] ?? ''))
			dataRow.eachCell((cell) => {
				cell.border = borderStyle
			})
		})

		// 두 번째 테이블 컬럼 너비도 고려하여 최대값으로 재조정
		slvColumns.forEach((col, index) => {
			let maxLength = String(col.headerName || '').length
			subRows.forEach((row: any) => {
				const cellValue = String(row[col.field] ?? '')
				if (cellValue.length > maxLength) {
					maxLength = cellValue.length
				}
			})
			const column = sheet.getColumn(index + 1)
			const newWidth = Math.min(Math.max(maxLength * 1.5 + 2, 10), 50)
			// 기존 너비와 비교하여 더 큰 값으로 설정
			if ((column.width || 0) < newWidth) {
				column.width = newWidth
			}
		})

		// 엑셀 파일 다운로드
		const buffer = await workbook.xlsx.writeBuffer()
		const blob = new Blob([buffer], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		})
		const url = window.URL.createObjectURL(blob)
		const a = document.createElement('a')
		a.href = url
		a.download = `혈액배양통계_${moment().format('YYYYMMDD_HHmmss')}.xlsx`
		a.click()
		window.URL.revokeObjectURL(url)
	}

	// 내부사용자일 경우 거래처 선택 팝업
	const [clientDialogOpen, setClientDialogOpen] = useState(false)
	const [searchClientName, setSearchClientName] = useState('')
	const clientDialogClose = () => {
		setClientDialogOpen(false)
	}
	const clientPopupOpenAction = () => {
		setClientDialogOpen(true)
	}
	const clientPopupSubmit = (e: any) => {
		setSearchClientName(e.ClientName)
		setSearch({
			...search,
			clientID: e.ClientID,
		})
		setClientDialogOpen(false)
	}

	// calulate today before n months
	const getBeforeMonth = (n: number) => {
		setSearch({
			...search,
			startDate: moment().subtract(n, 'months').format('YYYY-MM-DD'),
		})
	}

	// calulate today before 1 year
	const getBeforeYear = (n: number) => {
		setSearch({
			...search,
			startDate: moment().subtract(n, 'years').format('YYYY-MM-DD'),
		})
	}

	const searchDateRanageOnChange = (event: any) => {
		switch (event.target.value) {
			case '1m':
				getBeforeMonth(1)
				break
			case '3m':
				getBeforeMonth(3)
				break
			case '6m':
				getBeforeMonth(6)
				break
			case '1y':
				getBeforeYear(1)
				break
			default:
				break
		}
		setDateRange(event.target.value)
		setDisabledSearch(false)
	}

	// date picker on change event
	const dateRanageOnChange = (e: any, target: string) => {
		if (moment(new Date(e)).isBefore('2023-08-01')) {
			alertModal('2023-08-01 이전 날짜는 조회할 수 없습니다.', 'error', () => {})
			setSearch({
				...search,
				startDate: '2023-08-01',
			})
			return
		} else {
			if (moment(new Date(e)).format('yyyy-MM-DD').length === 10) {
				if (!isValidDateType(e)) {
					alertModal('날짜 형식이 올바르지 않습니다.', 'error', () => {})
					setDisabledSearch(true)
					return
				}

				if (target === 'startDate') {
					let diffValue = compareDate(e, search.endDate)
					if (diffValue > 0) {
						alertModal('시작일이 종료일보다 큽니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
					if (
						moment(search.endDate, ['YYYY-MM-DD', 'YYYY-MM'], true)
							.startOf('day')
							.diff(moment(e).startOf('day'), 'months', true) > 12
					) {
						alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				} else if (target === 'endDate') {
					let diffValue = compareDate(e, search.startDate)
					if (diffValue < 0) {
						alertModal('종료일이 시작일보다 작습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
					if (
						moment(e)
							.startOf('day')
							.diff(
								moment(search.startDate, ['YYYY-MM-DD', 'YYYY-MM'], true).startOf(
									'day',
								),
								'months',
								true,
							) > 12
					) {
						alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				}

				setDisabledSearch(false)

				setSearch((prevState) => {
					return {
						...search,
						[target]: moment(new Date(e)).format('yyyy-MM-DD'),
					}
				})
			} else {
				setDisabledSearch(true)
			}
		}
	}

	// grid
	const mstRef = useGridApiRef()
	const slvtRef = useGridApiRef()
	const [rows, setRows] = useState([])
	const [subRows, setSubRows] = useState([])
	const [gridMstLoading, setGridMstLoading] = useState(false)
	const [gridMstPageSize, setGridMstPageSize] = useState(env.row ? env.row : 100)
	const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([])
	const [subSelectionModel, setSubSelectionModel] = useState<GridSelectionModel>(
		[],
	)

	useEffect(() => {
		if (userInfo?.infoType === 'C') actionSearch()
	}, [])

	return (
		<>
			<ClientSearchPopup
				dialogOpen={clientDialogOpen}
				dialogClose={clientDialogClose}
				popupSubmit={clientPopupSubmit}
			/>
			<Stack
				sx={{
					position: 'sticky',
					top: '50px',
					zIndex: 100,
					padding: '0.5rem',
					borderRadius: '0.5rem',
					backgroundColor:
						theme.palette.mode === 'dark' ? 'rgba(50, 48, 54, 1)' : '#fff',
					'@media (max-width: 600px)': {
						position: 'relative',
						paddingTop: '15px',
						top: '0px',
					},
				}}
			>
				<PageWrap style={{ marginBottom: '0.5rem' }}>
					<PageBg2 sx={{ padding: '0.3rem 0.3rem 0rem 0.5rem' }}>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb"
							sx={{
								'@media (max-width: 900px': {
									display: 'none',
								},
							}}
						>
							<TitleText
								key="3"
								color="text.primary"
								sx={{ fontWeight: '500', fontSize: 17 }}
							>
								혈액배양 양성률-오염률 통계
							</TitleText>
						</Breadcrumbs>
						<BtnBox>
							<div>
								<span>
									<Button
										size="small"
										color="success"
										variant="contained"
										startIcon={isMdUp && <RotateLeftIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledReset}
										onClick={actionReset}
									>
										초기화
									</Button>
								</span>
								<span>
									<Button
										size="small"
										color="primary"
										variant="contained"
										startIcon={isMdUp && <ContentPasteSearchTwoToneIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledSearch}
										onClick={actionSearch}
									>
										조회
									</Button>
								</span>
								<span>
									<Button
										variant="contained"
										color="secondary"
										size="small"
										startIcon={<DownloadIcon />}
										onClick={actionExcelDownload}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
									>
										엑셀 다운로드
									</Button>
								</span>
								<span>
									<Button
										variant="contained"
										color="secondary"
										size="small"
										startIcon={<DownloadIcon />}
									>
										리포트 다운로드
									</Button>
								</span>
							</div>
						</BtnBox>
					</PageBg2>
				</PageWrap>
				<Box
					component="form"
					noValidate
					autoComplete="off"
					onKeyUp={onKeyUp}
					sx={{
						borderTop:
							theme.palette.mode === 'dark'
								? '1px solid rgba(81, 81, 81, 1)'
								: '1px solid #ccc',
						paddingTop: '1rem',
					}}
				>
					<LocalizationProvider
						dateAdapter={AdapterDayjs}
						adapterLocale={locale}
						dateFormats={{
							monthAndYear: 'YYYY년 M월',
						}}
					>
						<SearchRowItem>
							<p className="labelText">조회조건</p>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="searchType-select-label">기간 유형</InputLabel>
										<Select
											labelId="searchType-select-label"
											id="searchTypee-simple-select"
											value={search.searchType}
											label="기간 유형"
											onChange={(e) => {
												setSearch({
													...search,
													searchType: e.target.value,
												})
											}}
											size={'small'}
										>
											<MenuItem value={'R'}>접수일자</MenuItem>
											{/* <MenuItem value={'D'}>보고일자</MenuItem> */}
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={4}
								>
									<Grid
										container
										spacing={1}
									>
										<Grid
											item
											xs={6}
										>
											<DatePicker
												views={['month', 'year']}
												label="시작월"
												minDate={dayjs('2018-03-01')}
												maxDate={dayjs(new Date())}
												inputFormat="YYYY-MM"
												value={search.startDate}
												onChange={(newValue) => {
													dateRanageOnChange(newValue, 'startDate')
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														inputProps={{
															...params.inputProps,
															readOnly: true,
														}}
														helperText={null}
														size="small"
														fullWidth
													/>
												)}
											/>
										</Grid>
										<Grid
											item
											xs={6}
										>
											<DatePicker
												views={['month', 'year']}
												label="종료월"
												minDate={dayjs('2018-03-01')}
												maxDate={dayjs(new Date())}
												inputFormat="YYYY-MM"
												value={search.endDate}
												onChange={(newValue) => {
													dateRanageOnChange(newValue, 'endDate')
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														inputProps={{
															...params.inputProps,
															readOnly: true,
														}}
														helperText={null}
														size="small"
														fullWidth
													/>
												)}
											/>
										</Grid>
									</Grid>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={3}
								>
									<FormControl fullWidth>
										<InputLabel id="date-range-select-label">조회 기간</InputLabel>
										<Select
											labelId="date-range-select-label"
											id="date-range-simple-select"
											value={dateRange}
											label="조회 기간"
											onChange={searchDateRanageOnChange}
											size={'small'}
										>
											<MenuItem value={'0'}>선택하세요.</MenuItem>
											<MenuItem value={'1m'}>1개월</MenuItem>
											<MenuItem value={'3m'}>3개월</MenuItem>
											<MenuItem value={'6m'}>6개월</MenuItem>
											<MenuItem value={'1y'}>1년</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								{(userInfo.infoType === 'S' || userInfo.infoType === 'W') && (
									<Grid
										item
										xs={6}
										sm={3}
										md={3}
									>
										<TextField
											label="거래처"
											variant="outlined"
											size="small"
											type="text"
											fullWidth
											aria-readonly={true}
											value={searchClientName}
											onClick={clientPopupOpenAction}
										/>
									</Grid>
								)}
							</Grid>
						</SearchRowItem>
					</LocalizationProvider>
				</Box>
			</Stack>
			<Paper
				elevation={0}
				sx={{ width: '100%', overflow: 'hidden', mt: 2 }}
			>
				<Grid container>
					<Grid
						item
						xs={12}
					>
						<PageBg>
							<Box
								sx={{
									height: 'calc(100vh - 250px)',
									'@media (max-width: 1199px)': {
										height: '400px',
										overflow: 'auto',
									},
								}}
							>
								<Box sx={{ height: '50%' }}>
									<DataGridPremium
										rows={[]}
										apiRef={mstRef}
										columns={columns}
										pageSize={gridMstPageSize}
										onPageSizeChange={(newPageSize) => setGridMstPageSize(newPageSize)}
										rowsPerPageOptions={[5, 10, 20, 50, 100]}
										pagination
										autoHeight={false}
										loading={gridMstLoading}
										components={{
											Toolbar: GridToolbar,
											LoadingOverlay: LinearProgress,
										}}
										selectionModel={selectionModel}
										onSelectionModelChange={(newSelection) => {
											setSelectionModel(newSelection)
										}}
										localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
										componentsProps={{
											toolbar: {
												csvOptions: { disableToolbarButton: true },
												excelOptions: { disableToolbarButton: true },
												printOptions: { disableToolbarButton: true },
												showQuickFilter: false,
												quickFilterProps: { debounceMs: 250 },
											},
										}}
										density={(env.desnse as GridDensity) || 'compact'}
										initialState={{
											columns: {
												columnVisibilityModel: {
													ReceptionID: false,
													id: false,
												},
											},
										}}
										experimentalFeatures={{ columnGrouping: true }}
										columnGroupingModel={groupingModel}
										sx={{
											'& .MuiDataGrid-columnHeaderTitleContainer': {
												fontSize: '13px',
											},
											'& .MuiDataGrid-cell': {
												fontSize: '13px !important',
												borderRight:
													theme.palette.mode === 'dark'
														? '1px solid rgba(81, 81, 81, 1)'
														: '1px solid rgba(224, 224, 224, 1)',
											},
										}}
									/>
								</Box>
								<Box sx={{ height: '50%', mt: 2 }}>
									<DataGridPremium
										rows={[]}
										apiRef={slvtRef}
										columns={columnsSub}
										selectionModel={subSelectionModel}
										onSelectionModelChange={(newSelection) => {
											setSubSelectionModel(newSelection)
										}}
										initialState={{
											columns: {
												columnVisibilityModel: {},
											},
										}}
									/>
								</Box>
							</Box>
						</PageBg>
					</Grid>
				</Grid>
			</Paper>
		</>
	)
}
export default BloodStat
